import React, { FC, useState } from "react";
import { DialogContent, FormControlLabel, Stack, Switch } from "@mui/material";
import { BrandModal } from "../_shared/BrandModal";

export type SettingsProps = {
  open: boolean;
  onClose: () => void;
  kioskMode: boolean;
  setKioskMode: (kioskMode: boolean) => void;
  darkMode: boolean;
  setDarkMode: (darkMode: boolean) => void;
};

export const SettingsMenu: FC<SettingsProps> = ({
  open,
  onClose,
  kioskMode,
  setKioskMode,
  darkMode,
  setDarkMode,
}) => {
  const [adminCounter, setAdminCounter] = useState(0);

  const handleTitleClick = () => {
    setAdminCounter(adminCounter + 1);
  };
  return (
    <BrandModal
      open={open}
      onClose={onClose}
      title="SETTINGS"
      maxWidth="xs"
      onTitleClick={handleTitleClick}
    >
      <DialogContent>
        <Stack spacing={2}>
          <FormControlLabel
            sx={{
              justifyContent: "space-between",
              marginLeft: 0,
              marginRight: 0,
            }}
            labelPlacement="start"
            control={
              <Switch
                checked={darkMode}
                onChange={(_, checked) => setDarkMode(checked)}
              />
            }
            label="Dark Theme"
          />
          {adminCounter > 10 && (
            <>
              <FormControlLabel
                sx={{
                  justifyContent: "space-between",
                  marginLeft: 0,
                  marginRight: 0,
                }}
                labelPlacement="start"
                control={
                  <Switch
                    checked={kioskMode}
                    onChange={(_, checked) => setKioskMode(checked)}
                  />
                }
                label="Kiosk Mode"
              />
            </>
          )}
        </Stack>
      </DialogContent>
    </BrandModal>
  );
};
